<template>
  <BaseSideBar>
    <!-- list of Statuses -->
    <transition-group tag="div" name="menu-open-mobile">
      <div key="child">
        <SideBarTitle
          :title="$t('sideBar.invocies.title')"
          mode="invocies"
          iconName="mdi-invoice-text-outline"
          :isSideBarTitleShown="!needToCloseSideBar"
        />

        <div v-if="!needToCloseSideBar" class="mb-10">
          <h4 class="sub-list-title">
            {{ $t("sideBar.invocies.titleListOne") }}
          </h4>
          <SideBarList
            :isSideBarListDisplay="!needToCloseSideBar"
            :Statuses="Statuses"
            mode="invocies"
          />
        </div>

        <h4 v-if="!needToCloseSideBar" class="sub-list-title">
          {{ $t("sideBar.invocies.titleListTwo") }}
        </h4>
        <SideBarList
          :isSideBarListDisplay="!needToCloseSideBar"
          :Statuses="getReturnCustDocsStatuses"
          mode="returncustdocs"
        />
      </div>
    </transition-group>
  </BaseSideBar>
</template>

<script>
import BaseSideBar from "./BaseSideBar.vue";

import { mapGetters } from "vuex";
import SideBarTitle from "./SideBarTitle.vue";
import SideBarList from "./SideBarList.vue";

export default {
  components: {
    BaseSideBar,
    SideBarTitle,
    SideBarList,
  },
  data() {
    return {};
  },
  computed: {
    isLangHebrew() {
      return this.getUserLang == "he" ? true : false;
    },
    needToCloseSideBar() {
      if (
        (this.$store.getters.isMobile || this.$store.getters.isTablet) &&
        !this.$store.state.openMenu
      ) {
        // this.$store.commit("toggleMenu");
        return true;
      } else {
        return false;
      }
    },
    ...mapGetters({
      Statuses: "Invoices/getInvoicesStatuses",
      getReturnCustDocsStatuses: "Invoices/getReturnCustDocsStatuses",
      getUserLang: "AuthModule/getUserLang",
    }),
    getParamStatus() {
      return this.$route.params.status;
    },
  },
};
</script>

<style scoped lang="scss">
.sub-list-title:before {
  content: "| ";
  color: $invoicesAndReturns;
  width: 5px;
  height: 16px;
  background: $invoicesAndReturns;
  border-radius: 50px;
  margin-left: 10px;
}

.sub-list-title {
  padding-right: 15px;
  margin-bottom: 15px;
  font-size: $mediumTextSize;
  font-weight: 700;
  line-height: 21.33px;
  text-align: right;
}
.title-section {
  padding: 0px 20px 0px 20px;
}
.orders-icon {
  color: $ordersMainColor;
  background-color: #44a5e233;
  border-radius: 50%;
  padding: 17px;
}
@media (max-width: 601px) {
  .side-bar-container {
    padding: unset;
  }
}
.menu-open-mobile-enter-from,
.menu-open-mobile-leave-to {
  max-height: 0px;
}
.menu-open-mobile-enter-active,
.menu-open-mobile-leave-active {
  transition: all 0.2s ease;
  overflow: hidden;
}
.menu-open-mobile-enter-to,
.menu-open-mobile-leave-from {
  max-height: 1000px;
}
h2 {
  font-size: 30px;
  font-weight: 700;
  color: $ordersMainColor;
  line-height: 35.55px;
  text-align: right;
}

.material-icons {
  font-size: unset;
}
.collection-item {
  text-decoration: none;
  span {
    font-weight: 400;
    padding: 10px;
  }
}
.menu-collection {
  .v-list-item-title {
    font-size: $mediumTextSize;
    font-weight: 400;
    line-height: 21.33px;
    text-align: right;
    color: $statusListColor;
  }
}
</style>
